import React from 'react';
import { ComboBoxParam, Form, Row, SonForm, SubmitButton, useForm } from '../../../Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import {
  ContentSelectComboBoxForForm2,
  ListBoxModifier,
} from '../../../../components/molecules/Form/components/ComboBox';

type FileLinkFormProps = {
  form: SonForm<ComboBoxParam<'fileResourceReference'>>;
  refresh(): void;
};

export function AttachedFilesBaseFileLinkForm({ form, refresh }: FileLinkFormProps) {
  const { t } = useSonTranslation('AttachedFiles');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: refresh,
  });

  const combobox = params.getByName('fileResourceReference');

  return (
    <Form id="attached-files-file-link-form" {...formProps}>
      <Row modifier="block">
        <ContentSelectComboBoxForForm2
          name={combobox.name}
          suggestUrl={combobox.comboBoxUrl.url}
          required={combobox.required}
          labelTitle={t('fileLink.labelTitle')}
          labelHelpText={t('fileLink.labelHelpText')}
          modifierListBox={ListBoxModifier.RELATIVE}
          valueKey="resourceReference"
        />
      </Row>
      <SubmitButton
        buttonLabel={t('fileLink.button')}
        messageSuccess={t('fileLink.status.success')}
        messageSending={t('fileLink.status.sending')}
        messageFail={t('fileLink.status.fail')}
        customErrorTypeMessages={{
          invalidFile: t('fileLink.errorTypeMessages.invalidFile'),
        }}
        fetchState={fetchState}
      />
    </Form>
  );
}
